var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"position":"relative"}},[_vm._m(0),_c('img',{staticClass:"wemImg",attrs:{"src":_vm.tupian,"alt":""}})])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex align_items_c btnitem"},[_c('img',{attrs:{"src":"https://res.metaera.hk/resources/assets/images/home/685.png","alt":""}}),_c('div',{staticStyle:{"font-size":"12px","margin-left":"4px","font-weight":"400"}},[_vm._v("分享")])])
}]

export { render, staticRenderFns }